import React from 'react';
export function SocialProof() {
  return <section className="pt-16 pb-10 md:pt-20 md:pb-14 bg-[#1F2A24]" data-id="element-269">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-270">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-4 text-center" data-id="element-271">
          <div className="flex flex-col items-center" data-id="element-272">
            <span className="text-4xl md:text-5xl font-black text-white tracking-tight mb-2" data-id="element-273">
              +300
            </span>
            <span className="text-sm md:text-base text-[#C76F4A]" data-id="element-274">
              profes confían
            </span>
          </div>

          <div className="flex flex-col items-center" data-id="element-275">
            <span className="text-4xl md:text-5xl font-black text-white tracking-tight mb-2" data-id="element-276">
              12+6
            </span>
            <span className="text-sm md:text-base text-[#C76F4A]" data-id="element-277">
              Tomos + Bonus
            </span>
          </div>

          <div className="flex flex-col items-center" data-id="element-278">
            <span className="text-4xl md:text-5xl font-black text-white tracking-tight mb-2" data-id="element-279">
              4.9/5
            </span>
            <span className="text-sm md:text-base text-[#C76F4A]" data-id="element-280">
              calificación ⭐
            </span>
          </div>

          <div className="flex flex-col items-center" data-id="element-281">
            <span className="text-4xl md:text-5xl mb-2 leading-none" data-id="element-282">🇦🇷</span>
            <span className="text-sm md:text-base text-[#C76F4A]" data-id="element-283">
              Argentina
            </span>
          </div>
        </div>
      </div>
    </section>;
}